import { FeedDisplayType, FeedItemModel } from "outbound-api-client/lib/models";
import { apiService } from "../../services";

export const getFeedItems = async (feedDisplayType: FeedDisplayType): Promise<FeedItemModel[]> => {
  return apiService.instance.getFeedItems("en", feedDisplayType);
}
